import {Divider, Row} from 'antd'
import React from 'react'
import '../../asset/less/component.css'
import ArtworkSelectionPanel from '../../component/base/ArtworkSelectionPanel'
import PropTypes from "prop-types";
import {getArtwork, getArtworkAdmin} from "../../api/artworks";
import {is_admin_user} from "../../app/role";

const AddExhibitionArtwork = (props) => {

    const layout = props.artistIds.map((artistId)=>{
        const onRequestData = (pageId, pageSize, order, filters, search) => {
            const requestFunc = is_admin_user(props) ? getArtworkAdmin : getArtwork
            return requestFunc(pageId, pageSize, order, search, artistId, filters, props.cancelToken ?? null)
        }
        return (
            <>
                <Divider style={{marginTop: 12, marginBottom: 12}}/>
                <Row>
                    <ArtworkSelectionPanel artistId={artistId}
                                           initTargetKeys={props.initTargetKeys}
                                           requestData={onRequestData}
                                           onTargetKeysChange={(keys) => {
                                               if (props.onTargetKeysChange)
                                                   props.onTargetKeysChange(keys)
                                           }}/>
                </Row>
            </>

        )
    })

    return (
        <>
            {layout}
        </>
    )
}

// Setting default values for the props of AddExhibitionArtwork
AddExhibitionArtwork.defaultProps = {
    initTargetKeys: [],
    role: 'artist',
    cancelToken: null
};

// Typechecking props for the AddExhibitionArtwork
AddExhibitionArtwork.propTypes = {
    initTargetKeys: PropTypes.array,
    artistId: PropTypes.string,
    role: PropTypes.string,
    cancelToken: PropTypes.any,
    onTargetKeysChange: PropTypes.func
}

export default AddExhibitionArtwork;